import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

import drop_arrow from 'assets/icons/drop_purple.svg';

class Collapse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: false,
        }
        this.contentRef = React.createRef();
        this.handleBtnClick = this.handleBtnClick.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);

        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                active: false
            });
        }
    };

    handleBtnClick() {
        this.props.handleCollapseState(this.props.id);

        if(this.props.open === undefined) {
            let new_state  = !this.state.active;
            this.setState({active:new_state});
        }
    }

    render() {

        let { className = '', label = 'undefined button label', open = null, id = null, closeOnSelect = true, custom_arrow} = this.props;
        //either use internal state or from props for shared state
        let open_state = open === null ? this.state.active : open;

        let style = {};
        if(open_state && this.contentRef.current!==null) {
            let height   = this.contentRef.current?.clientHeight;
            style.height = height;
        }

        return (
            <div className= {"collapse_wrapper " + className + (open_state ? ' active' : '')}>
                <button className="button"
                        onClick = { () => this.handleBtnClick(id) }
                        aria-label="הצג מידע מורחב">
                    <span className="label">{ label }</span>
                    <img src= {custom_arrow ? custom_arrow : drop_arrow } className="arrow" alt="" />
                </button>
                <div className="collapse" style = { style }>
                    <div className="content" ref = { this.contentRef } onClick= { closeOnSelect ? this.handleBtnClick : null}>
                        { this.props.children }
                    </div>
                </div>
            </div>
        )
    }
}

export default Collapse;
